import { observable, action, flow, computed, runInAction } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Modal, Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './StoreAgentMsgServ';
import MsgAddServ from 'pages/Shop/Member/MsgAdd/MsgAddServ';
import * as _ from 'lodash';
class StoreAgentMsgMod {
  // A代B开卡，B的id，传给后台,新客注册时候用到(其他场景无此字段)
  @observable agentId = '';

  @observable dgUserId = ''; // 代客userId
  // 证件类型
  @observable identityType = '';
  @observable identityCard = '';
  // 证件图片
  @observable imgList = [];
  // 报错信息
  @observable errorMessage = '';
  @observable examine = 0;
  @observable errorStatus = 0;
  // 实体卡号、实体卡密码
  @observable physicalCardNum = '';

  @observable physicalCardPwd = '';

  // 商户名称、经营地址、详细地址
  @observable businessName = '';

  @observable businessAddress = null;

  @observable detailAddress = '';

  // 密码，重复密码
  // @observable password = '';

  // @observable passwordAgain = '';

  // 民族列表、银行总行列表、支行列表、支行模糊搜索关键字
  @observable nationList = [];

  @observable headBankList = [];

  // 用户的userId
  @observable userId = '';

  // 初始话的健康顾问编号、健康顾问编号、健康顾问姓名、销售顾问编号、销售顾问姓名、本人真实姓名。（健康顾问姓名为null代表未查是否有此人，为''时代表查无此人，为其它时，代表其名字， saleName同理）。
  @observable initHealthy = '';

  @observable healthy = '';

  @observable healthyName = null;

  @observable sale = '';

  @observable saleName = null;

  // 乘星吻月 安置网
  @observable areaResettle = Stores.AppMod.isWY ? '' : 'leftCardCode'; // ABC区 A区-leftCardCode B区-rightCardCode C区-centerCardCode

  @observable areaResettleDetail = {}; // 乘星吻月安置网情况

  @observable realName = '';

  @observable healthyStatus = '';

  @observable saleStatus = '';

  // 证件类型，证件号，生日，性别，由于picker的value 要数组，为方便，凡是select的value，都用数组存储值，取第一项就好了
  @observable certType = 1;

  // 所在区域
  @observable belongArea = 1;

  @observable certNum = '';

  @observable birth = '';

  @observable gender = '';

  // 文化程度，职业，民族
  @observable level = '';

  @observable job = '';

  @observable nation = '';

  // 银行地址选择、总行、支行、支行名、卡号
  @observable bankAddress = null;

  @observable headBankId = '';

  @observable branchBankId = '';

  @observable branchBankName = '';

  @observable bankNum = '';

  // 是否同意协议
  @observable isAgree = false;

  // 普客开卡卡类型列表
  @observable cardTypeList = [];

  // 根据销售顾问是否显示所在区域
  @observable isShowArea = false;

  @observable belongSystem = '';

  // 是否修改过销售顾问，乘星吻月体系修改销售顾问下单时要增加销售顾问限制3跳线的校验,只要销售顾问input框聚焦过就算修改，重新中ABC区需要将该标志位置回false
  @observable isSaleChange = false;

  @observable applyType = '';

  /**
   * 修改参数逻辑
   */
  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 初始化表单信息
   */
  @action
  initData() {
    const cardFillMsg = Util.getLocalCache(Config.localStorageKeys.member_cardFillMsg) || {};
    if (
      !cardFillMsg.phone ||
      cardFillMsg.phone != this.phone ||
      this.bankAddress ||
      this.headBankId ||
      this.branchBankId
    )
      return;
    const {
      businessName,
      businessAddress,
      detailAddress,
      // password,
      sale,
      realName,
      certType,
      certNum,
      birth,
      gender,
      level,
      job,
      nation,
      bankNum,
      bankAddress,
      headBankId,
      branchBankId,
      branchBankName
    } = cardFillMsg;
    this.changeState({
      businessName,
      businessAddress,
      detailAddress,
      // password,
      // passwordAgain: password,
      sale,
      realName,
      certType,
      certNum,
      birth,
      gender,
      level,
      job,
      nation,
      bankAddress,
      headBankId,
      branchBankId,
      branchBankName,
      bankNum
    });
    if (sale) {
      this.getMemberName('saleName', sale);
    }
  }

  /**
   * 清除全部数据
   */
  @action
  clear() {
    this.agentId = '';
    this.physicalCardNum = '';
    this.physicalCardPwd = '';
    this.businessName = '';
    this.businessAddress = null;
    this.detailAddress = '';
    this.nationList = [];
    this.headBankList = [];
    this.initHealthy = '';
    this.healthy = '';
    this.healthyName = null;
    this.sale = '';
    this.saleName = null;
    this.realName = '';
    this.certType = 1;
    this.certNum = '';
    this.birth = '';
    this.gender = '';
    this.level = '';
    this.job = '';
    this.nation = '';
    this.bankAddress = null;
    this.headBankId = '';
    this.branchBankId = '';
    this.branchBankName = '';
    this.bankNum = '';
    this.isAgree = false;
    this.belongArea = 1;
    this.isSaleChange = false;
    this.areaResettle = 'leftCardCode';
    this.areaResettleDetail = {};
  }

  /**
   * 获取民族列表
   */
  getNationList = flow(function* (memberNum) {
    try {
      const { data } = yield Serv.getNationList({ cardCode: memberNum });
      if (Array.isArray(data)) {
        this.nationList = data.map((_val) => ({
          label: _val.name,
          value: _val.id
        }));
      }
    } catch (error) {}
  });

  /**
   * DZC是否带出销售顾问，且不能更改
   */
  queryDZCMemberSaleNumber = flow(function* () {
    if (!this.healthy) return '';
    const { data, resultCode } = yield Serv.queryDZCMemberSaleNumber(this.healthy);
    // 存在注册时填写的健康顾问，将其显示并不可编辑
    if (resultCode == '0') {
      return data || '';
    }
    return '';
  });

  /**
   *校验销售顾问，DZC体系每个卡号最多当两个人的销售顾问
   *
   */
  checkSaleConsultNum = flow(function* () {
    const params = {
      healthConsultNum: this.healthy,
      saleConsultNum: this.sale
    };
    const { data, resultCode } = yield Serv.checkSaleConsultNum(params);
    // 存在注册时填写的健康顾问，将其显示并不可编辑
    if (resultCode == '0') {
      return true;
    }
    return false;
  });

  /**
   * 获取银行总行列表
   */
  getHeadBankList = flow(function* () {
    try {
      const { data } = yield Serv.getHeadBankList();
      if (Array.isArray(data)) {
        this.headBankList = data.map((_val) => ({
          label: _val.name,
          value: _val.id,
          name: _val.name
        }));
      }
    } catch (error) {}
  });

  /**
   * 获取用户姓名
   */
  // getMemberName = flow(function*(memberName, memberNum) {
  //   const {data, resultCode} = yield Serv.getMemberName({cardCode: memberNum});
  //   if (resultCode == '0' && data) {
  //     this[memberName] = data.length > 5 ? data[0] + '...' + data[data.length - 1] : data;
  //   }
  // });

  /**
   * 获取用户姓名
   * @param {String} memberName - healthyName健康顾问，saleName销售顾问
   * @param {String} memberNum - 用户卡号
   */
  getMemberName = flow(function* (memberName, memberNum) {
    const params = {
      cardCode: memberNum
    };
    if (
      !(
        this.applyType == '7' &&
        (Stores.AppMod.isCXY || Stores.AppMod.isWY) &&
        _.isEmpty(this.areaResettleDetail)
      ) &&
      memberName == 'saleName'
    ) {
      params.checkSaleNum = 1;
    }
    const { data, resultCode, resultMsg } = yield Serv.getMemberInfo(params);
    if (resultCode == '0' && data) {
      if (data.realName) {
        this[memberName] =
          data.realName.length > 5
            ? data.realName[0] + '...' + data.realName[data.realName.length - 1]
            : data.realName;
      } else {
        this[memberName] = '';
      }
      if (memberName == 'saleName') {
        this.saleStatus = this.getMemberStatus(data.status);
        this.belongSystem = data.belongSystem;
      } else {
        this.healthyStatus = this.getMemberStatus(data.status);
      }
    } else if (resultCode == '174401') {
      Toast.fail(resultMsg);
    } else {
      this.belongSystem = '';
      // Toast.info()
      if (resultCode != 0) {
        Toast.info(resultMsg);
        return;
      }
    }
    // 因为证件类型是根据会员的体系和人群包设置的所以清空证件类型
    this.certType = 1;
  });

  getMemberStatus = (status) => {
    switch (status) {
      case 0:
        return '有效';
      case 1:
        return '未激活';
      case 2:
        return '未续约';
      case 3:
        return '注销';
      case 4:
        return '冻结';
      case 5:
        return '休眠期';
      default:
        return '';
    }
  };

  /**
   * 民族校验
   */
  nationValidate = flow(function* () {
    try {
      const { resultCode } = yield Serv.nationValidate({
        healthConsultantNum: this.healthy,
        nation: this.nation
      });
      return resultCode;
    } catch (error) {}
  });

  /**
   * 乘星吻月站点，会员代客注册，获取推荐人安置情况
   */
  loadAreaResettleData = flow(function* () {
    if (!this.healthy) return;
    try {
      const { data } = yield Serv.loadAreaResettleData(this.healthy);
      if (data) {
        this.areaResettleDetail = data || {};
        if (!Stores.AppMod.isWY) {
          // 不显示左右区的时候，左右区卡号一样，显示左右区的时候，默认选中左区，所以默认赋值左区卡号
          this.sale = this.areaResettleDetail.leftCardCode || this.healthy;
          // 请求销售顾问卡号对应的卡名称和卡状态
          this.getMemberName('saleName', this.sale);
        }
      }
    } catch (error) {}
  });

  submit = flow(function* ({ ldOrder, baseInfoRequired, cardCode = '' }) {
    // 只有允许显示的时候才会判断表单数据否则直接进行下一步
    const { isInternationalized, userInfo } = Stores.AppMod;
    const {
      errorMessage,
      certNum,
      errorStatus,
      examine,
      imgList,
      identityCard,
      identityType,
      realName
    } = this;
    const dgAreaCode = localStorage.getItem('dgAreaCode') || 86;

    // 判断是会否需要审核 只有需要审核的情况下 才会走下面逻辑
    if (examine == 1) {
      if (baseInfoRequired == 1) {
        if (
          !(
            isInternationalized &&
            identityType == 3 &&
            (this.dgUserId ? dgAreaCode : userInfo.areaCode) == 886
          ) &&
          imgList.length != 2
        ) {
          Toast.fail('请上传身份证正反面照片', 1);
          return;
        }
        if (!identityType) {
          Toast.fail('请选择证件');
          return;
        }
        if (!certNum) {
          Toast.fail('请输入证件号码');
          return;
        }
      }

      // 有错误信息且加入了黑名单的才会弹窗
      if (errorMessage && (errorStatus == 3 || errorStatus == 0)) {
        Modal.alert('温馨提示', errorMessage, [
          {
            text: '我已知晓',
            onPress: () => {
              Toast.hide();
            }
          }
        ]);
        return;
      }
    } else {
      if (baseInfoRequired == 1) {
        if (!identityType) {
          Toast.fail('请选择证件');
          return;
        }
        if (!certNum) {
          Toast.fail('请输入证件号码');
          return;
        }
      }
    }

    if (this.examine == 1) {
      const orderParams = Util.getLocalCache(Config.localStorageKeys.shop_checkOrderParams);
      MsgAddServ.examineAdd({
        identityCard: this.certNum,
        identityType: this.identityType,
        identityFront: this.imgList[0],
        identityBack: this.imgList[1],
        cardCode: cardCode,
        userId: Stores.AppMod.userInfo.id,
        dgUserId: orderParams.dgUserId,
        submitChannel: 1,
        // realName 如果加密就传空
        realName: realName && realName.indexOf('*') > -1 ? '' : realName
      })
        .then((res) => {
          if (res.status == 3) {
            Modal.alert('温馨提示', res.msg, [
              {
                text: '我已知晓',
                onPress: () => {
                  this.submitCardMsg({ ldOrder });
                  Toast.hide();
                }
              }
            ]);
          } else {
            this.submitCardMsg({ ldOrder });
          }
        })
        .catch((msg) => {
          Modal.alert('温馨提示', msg, [
            {
              text: '我已知晓',
              onPress: () => {
                const { userType } = Stores.AppMod;
                if ([3, 5].includes(userType)) {
                  window.app.routerRedirect({
                    pathname: '/store'
                  });
                } else {
                  window.app.routerRedirect({
                    pathname: '/personal'
                  });
                }
                Toast.hide();
              }
            }
          ]);
        });
    } else {
      this.submitCardMsg({ ldOrder });
    }
  });
  /**
   * 店铺新客注册
   */
  submitCardMsg = flow(function* ({ ldOrder }) {
    try {
      const {
        physicalCardNum,
        physicalCardPwd,
        businessName,
        certType,
        headBankId,
        headBankList,
        belongSystem,
        belongArea,
        sale,
        errorMessage,
        errorStatus,
        examine,
        imgList,
        identityCard,
        identityType
      } = this;

      // if (!physicalCardNum) {
      //   if (password.length < 6) {
      //     Toast.info('密码长度不能少于6位', 1);
      //     return;
      //   }
      //   if (!Util.checkInput(password, 'password')) {
      //     Toast.info('密码需由大小写字母和数字组成', 2);
      //     return;
      //   }
      //   if (password !== passwordAgain) {
      //     Toast.info('两次输入的密码不匹配', 1);
      //     return;
      //   }
      // }
      if (businessName && !Util.checkInput(businessName, 'nonSymbol')) {
        Toast.info('商户名称仅限输入中英文数字', 1);
        return;
      }
      if (!Util.getStrictName(this.realName)) return;
      let params = {
        bizValetCardReqDto: {
          healthConsultantNum: this.healthy,
          saleConsultantNum: this.sale ? this.sale : this.healthy,
          realName: this.realName.trim(),
          identityType: this.certType,
          identityCard: this.certNum,
          birthday: this.birth,
          sex: this.gender,
          helpUserId: this.agentId,
          channel: 2,
          agree: true
        },
        confirmReqDto: {
          userId: Stores.AppMod.userInfo.id,
          channel: 2
        }
      };

      if (belongArea && (belongSystem == 'WDY' || belongSystem == 'DC' || belongSystem == 'CSS')) {
        // params.registerCardReqDto.belongArea = belongArea;
        Stores.CheckOrderMod.changeState({ belongArea, sale });
        params.bizValetCardReqDto.belongArea = belongArea;
      }

      if (this.nation || this.nation === 0) {
        params.bizValetCardReqDto.nation = this.nation;
      }
      // 如证件号为身份证，去掉生日和性别参数
      if (certType == 1) {
        delete params.bizValetCardReqDto.birthday;
        delete params.bizValetCardReqDto.sex;
      }
      // 非实体开卡时，需传密码和重复密码
      if (!physicalCardNum) {
        Object.assign(params.bizValetCardReqDto, {
          password: this.certNum ? rstr2b64(this.certNum.slice(-6)) : rstr2b64('123456'),
          confirmPassword: this.certNum ? rstr2b64(this.certNum.slice(-6)) : rstr2b64('123456'),
          isEntityCard: '0'
        });
      } else {
        let extension = {};

        headBankList.some((_val) => {
          if (_val.value == headBankId) {
            extension.bankName = _val.name;
            return true;
          }
        });
        if (this.businessAddress) {
          Object.assign(extension, {
            manageProvinceCode: this.businessAddress[0].value,
            manageCityCode: this.businessAddress[1].value,
            manageCountyCode: this.businessAddress[2].value
          });
        }
        Object.assign(
          params.bizValetCardReqDto,
          {
            bankNativePlaceProvinceCode: this.bankAddress[0].value,
            bankNativePlaceCityCode: this.bankAddress[1].value,
            branchCode: this.branchBankId,
            bankAccount: this.bankNum,
            entityCardCode: physicalCardNum,
            entityPassword: physicalCardPwd,
            address: this.detailAddress,
            educational: this.level,
            job: this.job,
            isEntityCard: '1'
          },
          extension
        );
        if (this.businessName) params.bizValetCardReqDto.merchantName = this.businessName;
      }
      if (localStorage.getItem('noOrderToOpenCard') == 1) {
        runInAction(() => {
          Stores.CheckOrderMod.changeState({ orderType: 7 });
        });
        setTimeout(() => {
          Util.setLocalCache(
            Config.localStorageKeys.member_storeAgentApplyCardMsg,
            params.bizValetCardReqDto
          );
          Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
            dgUserId: this.agentId
          });
          Stores.CheckOrderMod.addOrder('', 1);
        }, 100);
        return;
      }
      if (ldOrder) {
        Util.setLocalCache(
          Config.localStorageKeys.member_storeAgentApplyCardMsg,
          params.bizValetCardReqDto
        );
        Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
          dgUserId: this.agentId
        });
        Stores.CheckOrderMod.confirmLDOrder({ type: 3 });
        return;
        return;
      }

      if (Stores.AppMod.isCXY || Stores.AppMod.isWY) {
        Util.setLocalCache(Config.localStorageKeys.modifySaleTag, this.isSaleChange ? 1 : 0);
      }

      const { data } = yield Serv.submitCardMsg(params, 1);
      Toast.success('提交成功', 1, () => {
        Util.setLocalCache(
          Config.localStorageKeys.member_storeAgentApplyCardMsg,
          params.bizValetCardReqDto
        );

        Util.setLocalCache(Config.localStorageKeys.member_cardTypeData, data);

        Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
          dgUserId: this.agentId,
          cardType: data.cardType
        });
        // 缓存填写的信息，以便下次同个手机号进来，无需再次填写
        Util.setLocalCache(Config.localStorageKeys.member_cardFillMsg, {
          phone: this.phone,
          businessAddress: this.businessAddress,
          businessName: this.businessName,
          detailAddress: this.detailAddress,
          // password: this.password,
          sale: this.sale,
          realName: this.realName,
          certType: this.certType,
          certNum: this.certNum,
          birth: this.birth,
          gender: this.gender,
          level: this.level || '',
          job: this.job || '',
          nation: this.nation,
          bankAddress: this.bankAddress || null,
          headBankId: this.headBankId || this.headBankId == 0 || '',
          branchBankId: this.branchBankId || '',
          branchBankName: this.branchBankName,
          bankNum: this.bankNum || ''
        });
        window.app.routerGoTo({
          pathname: '/shop/checkOrder'
          // state: {
          //   // '7'代表店铺新客注册类型的礼包选购
          //   applyType: '7',
          // },
        });
      });
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 按钮是否不可以点击
   */
  @computed
  get disabled() {
    const { isInternationalized, userInfo, cardInfo } = Stores.AppMod;
    const { baseInfoRequired } = cardInfo || {};
    const dgAreaCode = localStorage.getItem('dgAreaCode') || 86;
    let disabled_1 = !(
      `${this.healthy}` &&
      (Stores.AppMod.cardInfo.saleConsultantDisplay == 1 ? `${this.sale}` : true) &&
      `${this.realName}` &&
      `${this.certType}` &&
      `${this.certNum}` &&
      `${(Stores.AppMod.internationalConfig || {}).hideNation ? true : this.nation}`
    );

    let disabled_2 = this.certType != 1 && !(this.birth && this.gender);
    if (baseInfoRequired == 0) {
      disabled_2 = false;
      disabled_1 = !(
        `${this.healthy}` &&
        (Stores.AppMod.cardInfo.saleConsultantDisplay == 1 ? `${this.sale}` : true) &&
        `${this.realName}` &&
        `${(Stores.AppMod.internationalConfig || {}).hideNation ? true : this.nation}`
      );
    }
    const disabled_3 = this.physicalCardNum && !(this.businessAddress && this.detailAddress);
    const disabled_4 =
      this.physicalCardNum &&
      !(
        `${this.level}` &&
        `${this.job}` &&
        `${this.bankAddress}` &&
        (this.headBankId || this.headBankId == 0) &&
        `${this.branchBankId}` &&
        `${this.bankNum}`
      );
    return (
      disabled_1 ||
      disabled_2 ||
      disabled_3 ||
      disabled_4 ||
      (this.examine == 1 &&
        !(
          isInternationalized &&
          this.certType == 3 &&
          (this.dgUserId ? dgAreaCode : userInfo.areaCode) == 886
        ) &&
        this.imgList.length != 2)
    );
  }
}
const storeAgentMsgMod = new StoreAgentMsgMod();
export default storeAgentMsgMod;



// WEBPACK FOOTER //
// ./src/pages/Store/BusinessManage/StoreAgentMsg/StoreAgentMsgMod.js